module.exports = __webpack_public_path__ + "media/images/emblems/Hombrechtikon-blazon-53df323b40d8ca038271d5332a70016f.svg";